import { MVSErgebnis, MVSParams } from '../types/mvs'
import { berechneAlteSteuer } from './mvs-alt-calculator'
import { berechneNeueSteuer } from './mvs-neu-calculator'

/**
 * Interface für das Vergleichsergebnis der beiden MVS-Berechnungen
 */
export interface MVSVergleichsErgebnis {
  altesSystem: MVSErgebnis
  neuesSystem: MVSErgebnis
  differenz: MVSDifferenz
}

/**
 * Interface für die Differenz zwischen altem und neuem System
 */
export interface MVSDifferenz {
  monatlich: number
  proIntervall: number
  jaehrlich: number
  monatlichProzent: number
  proIntervallProzent: number
  jaehrlichProzent: number
}

/**
 * Berechnet die MVS nach dem alten und neuen System und gibt das Vergleichsergebnis zurück
 * 
 * @param params Parameter für die MVS-Berechnung
 * @returns Vergleichsergebnis mit Berechnung nach altem und neuem System sowie der Differenz
 */
export function berechneVergleich(params: MVSParams): MVSVergleichsErgebnis {
  const altesSystem = berechneAlteSteuer(params)
  const neuesSystem = berechneNeueSteuer(params)
  
  // Differenzen berechnen
  const monatlich = neuesSystem.monatlicheSteuer - altesSystem.monatlicheSteuer
  const proIntervall = neuesSystem.steuerProIntervall - altesSystem.steuerProIntervall
  const jaehrlich = neuesSystem.steuerJaehrlich - altesSystem.steuerJaehrlich
  
  // Prozentuale Unterschiede berechnen
  // Sonderbehandlung für Division durch 0
  const monatlichProzent = altesSystem.monatlicheSteuer === 0 
    ? (neuesSystem.monatlicheSteuer === 0 ? 0 : 100) 
    : (monatlich / altesSystem.monatlicheSteuer) * 100
  
  const proIntervallProzent = altesSystem.steuerProIntervall === 0 
    ? (neuesSystem.steuerProIntervall === 0 ? 0 : 100) 
    : (proIntervall / altesSystem.steuerProIntervall) * 100
  
  const jaehrlichProzent = altesSystem.steuerJaehrlich === 0 
    ? (neuesSystem.steuerJaehrlich === 0 ? 0 : 100) 
    : (jaehrlich / altesSystem.steuerJaehrlich) * 100
  
  const differenz: MVSDifferenz = {
    monatlich,
    proIntervall,
    jaehrlich,
    monatlichProzent,
    proIntervallProzent,
    jaehrlichProzent
  }
  
  return {
    altesSystem,
    neuesSystem,
    differenz
  }
} 